module.exports = __webpack_public_path__ + "img/mir.8d954353.svg";